<template>
  <v-menu
    v-if="$vuetify.display.mdAndUp"
    light
    left
    min-width="225px"
    transition="slide-y-transition"
  >
    <template #activator="{ props }">
      <v-btn dark text title="Recently Viewed" v-bind="props"> Recent </v-btn>
    </template>
    <v-card>
      <v-list-subheader>Recently Viewed Funds</v-list-subheader>
      <v-list density="compact">
        <v-list-item v-if="funds.length === 0">
          <v-list-item-title>None</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-for="fund in funds"
          v-else
          :key="fund.id"
          :href="`/filer/${fund.permalink}`"
          target="_blank"
        >
          <v-list-item-title>{{ fund.name }}</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list-subheader>Recently Viewed Stocks</v-list-subheader>
      <v-list density="compact">
        <v-list-item v-if="stocks.length === 0">
          <v-list-item-title>None</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-for="stock in stocks"
          v-else
          :key="stock.id"
          :href="`/stock/${stock.permalink}`"
          target="_blank"
        >
          <v-list-item-title>{{ stock.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import api from '@/store/api'

export default {
  data: () => ({
    funds: [],
    stocks: []
  }),

  mounted() {
    api.get('filer.json?id=recent').then(response => {
      this.funds = response.data
    })

    api.get('stock.json?id=recent').then(response => {
      this.stocks = response.data
    })
  }
}
</script>
